export default __webpack_public_path__ + "static/media/last-year.de6248aa.csv";